import React, { useEffect, useState } from 'react';
import { ContentTemplate, TitleHeader } from 'web-library';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CreateCandidateForm from '../../modules/profile/components/CreateCandidateForm';
import { CreateCandidateFormLocationState } from '../../modules/profile/logic/useCreateCandidateForm';
import MyInfoNotFoundModal from '../../modules/profile/components/CandidateProfileForm/HelperComponents/MyInfoNotFoundModal';
import { useWOGAA } from '../../hooks/wogaa';

const CreateCandidate = ({ pathToEmailAlert }: { pathToEmailAlert: string }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { state } = useLocation<CreateCandidateFormLocationState>();
  const [isMyInfoNotFoundModalOpen, setIsMyInfoNotFoundModalOpen] = useState(false);

  const { transactionStart } = useWOGAA('myexamsseab-6476');
  transactionStart();
  const closeMyInfoNotFoundModal = (): void => {
    if (isMyInfoNotFoundModalOpen) {
      setIsMyInfoNotFoundModalOpen(false);
    }
  };

  useEffect(() => {
    if (state.hasMyInfoProfile === false) {
      setIsMyInfoNotFoundModalOpen(true);
    }
  }, [state.hasMyInfoProfile]);
  return (
    <>
      <TitleHeader title={t('profile->>CreateCandidateForm.Create Candidate')} />
      {isMyInfoNotFoundModalOpen && (
        <MyInfoNotFoundModal
          modelOpen={isMyInfoNotFoundModalOpen}
          onClickModalButton={() => {
            closeMyInfoNotFoundModal();
          }}
        />
      )}
      <ContentTemplate>
        <CreateCandidateForm
          onSubmitCallback={(isSingPassUser) => {
            if (isSingPassUser) {
              history.push('/');
            } else {
              history.push(pathToEmailAlert);
            }
          }}
        />
      </ContentTemplate>
    </>
  );
};

export default CreateCandidate;
